import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy `/copy/read/<magic_link>` — the GET LINK button in the sender's "card sent"
 * confirmation mail (`mailer.py` copy_link_url). Legacy's ShareLink page opened the
 * "Send by Link" dialog with the card's read link and moved to My Cards › Sent; we do the
 * same via `?copy_read=` on the Sent tab (My Cards is member-only, so a signed-out visitor
 * signs in first and comes straight back with the dialog).
 */
export const Route = createFileRoute("/copy/read/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/mycards/$type",
      params: { type: "sent" },
      search: { copy_read: params.slug },
      replace: true,
    });
  },
  component: () => null,
});
